export const responseFields = {
  DATA: 'dados',
  MESSAGES: 'mensagens'
};

export class HttpService {
  static ValidateResponseAsync(response) {
    return new Promise((resolve, reject) => {
      if (!response) {
        reject(['Problemas na requisição']);
      }

      const data = response[responseFields.DATA];
      const messages = response[responseFields.MESSAGES];
      
      if (data === null || data === undefined) {
        reject(messages);

        return;
      }

      if (data instanceof Array && !data.length) {
        reject(messages);
        return;
      }

      if (data instanceof Object && !Object.keys(data).length) {
        reject(messages);
        return;
      }

      resolve({ data, messages });
    });
  }

  static generateQueryStrings(filters = {}) {
    return Object.keys(filters)
      .filter(key => filters[key] !== null && filters[key] !== undefined)
      .map(key => `${key}=${filters[key]}`)
      .join('&');
  }
}
